import React, { useEffect, useState } from 'react';

/**
 * SYND-02 — /syndicated/:id, the half that answers a cold load.
 *
 * This is a shell, not a second implementation. +data.tsx has already emitted
 * the head server-side (the robots directive is the reason this route is a Vike
 * page at all); the body is pages/SyndicatedProperty.tsx, rendered by React
 * Router once App loads on the client.
 *
 * Deliberately NOT the /property/@slug arrangement, which duplicates its whole
 * page in Vike. That page needs server-rendered BODY copy to rank; this one is
 * `noindex, follow` by decision (SEO-01), so there is nothing to rank here and
 * a duplicate would only be a second place for the no-badge,
 * no-message-button rules to drift out of.
 *
 * App uses BrowserRouter, which needs `window`, so SSR renders the same empty
 * shell src/pages/[[catchAll]]/+Page.tsx renders and the SPA takes over on the
 * client — identical behaviour to every other client-routed page here.
 */
export default function SyndicatedPropertyPage() {
  const [AppComponent, setAppComponent] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    import('../../../../App').then((mod) => {
      setAppComponent(() => mod.default);
    });
  }, []);

  if (!AppComponent) {
    return <div className="min-h-screen" />;
  }

  return <AppComponent />;
}
